"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fonts = void 0;
var fonts = {
  body: 'Roboto, \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  heading: '\'Mr Eaves\', \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  lcScript: '\'LC Script\', \'Brush Script MT\', \'Times Italic\', \'Times New Roman\', cursive',
  mrEaves: '\'Mr Eaves\', \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  roboto: 'Roboto, \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  monospace: 'Menlo, monospace'
};
exports.fonts = fonts;